var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},_vm.$listeners),[_c('path',{attrs:{"d":"M97.6 70.4L53.2 26.2c-.9-.9-2.1-1.3-3.3-1.3-1.2 0-2.4.5-3.3 1.3L2.4 70.4c-1.1 1.1-1.1 2.8 0 3.9.5.5 1.2.8 1.9.8s1.4-.3 1.9-.8l43.6-43.6 43.8 43.6c1.1 1.1 2.8 1.1 3.9 0 1.2-1.1 1.2-2.8.1-3.9z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }